module.exports = __webpack_public_path__ + "static/media/group-1230.1a68e01c.svg";